import React, {useState} from 'react';
import {connect} from "react-redux";
import {ButtonGroup, ToggleButton} from "react-bootstrap";

import PaymentModal from "../PaymentModal";
import {PLANS, PLANS_IN} from "../../constants/plans";
import StudentVerification from "../StudentVerification";
import {QUARTERLY} from "../../constants/plans/pro-student";
import IndiaPromoBanner from "../IndiaPromo";
import PricingGrid from "../PricingGrid/PricingGrid";

import './ProPlans.css';

export const isFromIndiaCheck = () => false; // turned off for now ['Asia/Kolkata', 'Asia/Calcutta'].includes(Intl.DateTimeFormat().resolvedOptions().timeZone);

export const ProPlans = ({className, onFreeClick, email, hideFreeCard, hideTable, onPaymentClickCallback, onPaymentHideCallback, source}) => {
  const [showModal, setShowModal] = useState(false);
  const [pricingMode, setPricingMode] = useState("yearly");
  const [showStudentPlans, setShowStudentPlans] = useState(false);
  const [showStudentVerification, setShowStudentVerification] = useState(false);
  const [studentData, setStudentData] = useState();
  const [selectedPlan, setSelectedPlan] = useState();
  const isFromIndia = isFromIndiaCheck();

  const onSubPlanClick = (plan) => {
    setSelectedPlan(plan);
    setShowModal(true);

    if (onPaymentClickCallback) {
      onPaymentClickCallback()
    }
  }

  const onStudentContinue = (email, school) => {
    setStudentData({email, school});
    setShowStudentVerification(false);
    onSubPlanClick(PLANS.PRO_STUDENT);
  }

  const onPaymentModalHide = () => {
    setShowModal(false);

    if (onPaymentHideCallback)
      onPaymentHideCallback();
  }

  return (<>
    {showModal && <PaymentModal
      show={showModal}
      onHide={onPaymentModalHide}
      periodProp={showStudentPlans ? QUARTERLY : pricingMode}
      plan={selectedPlan}
      studentData={studentData}
      email={email}
      planSet={isFromIndia ? PLANS_IN : PLANS}
      source={source}
    />}
    <StudentVerification
      show={showStudentVerification}
      onHide={() => setShowStudentVerification(false)}
      onContinue={onStudentContinue}
    />
    <div id="pricing" className={`mt-3 mb-3 position-relative ${className}`}>
    {!showStudentPlans && <ButtonGroup>
      <ToggleButton
        id="monthly"
        className="cursor-pointer"
        size="sm"
        value="monthly"
        variant="outline-dark"
        type="radio"
        name="radio"
        checked={pricingMode === "monthly"}
        onChange={(e) => setPricingMode(e.currentTarget.value)}
      >
        Monthly
      </ToggleButton>
      <ToggleButton
        id="yearly"
        className="cursor-pointer"
        type="radio"
        name="radio"
        size="sm"
        variant="outline-dark"
        value="yearly"
        checked={pricingMode === "yearly"}
        onChange={(e) => setPricingMode(e.currentTarget.value)}
      >
        Yearly
      </ToggleButton>
    </ButtonGroup>}
    <IndiaPromoBanner show={isFromIndia} />
    <p className="mt-4 mb-5 text-sm">
      Questions? <span
      className="link color-purple"
      onClick={() => window.$crisp.push(['do', 'chat:open'])}
    >
      <u>Chat with us</u>
    </span>
      <div className="guarantee light-grey">
        🎖️ 7 day money back guarantee
      </div>
    </p>
    <div id="pricing" className="container-cards">
      <PricingGrid
        className="mt-4"
        period={pricingMode}
        onSubPlanClick={onSubPlanClick}
        onFreeClick={onFreeClick}
        hideFreeCard={hideFreeCard}
        hideTable={hideTable}
      />
    </div>
{/*

// TODO REMOVE THIS PLAN
  <div className="ms-auto me-auto mt-3" style={{ maxWidth: '250px' }}>
      <a
        className="cursor-pointer link color-purple"
        onClick={() => onStudentRegularPlanSwitch(!showStudentPlans)}
      >
        <u>View {showStudentPlans ? 'regular' : 'student'} plans</u>
      </a>
    </div>*/}
  </div>
  </>);
};

const mapDispatchToProps = (dispatch) => ({ dispatch });

export default connect(undefined, mapDispatchToProps)(ProPlans);
